module.exports = __webpack_public_path__ + "static/media/flag-spain.7b49f686.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/LanguageFlag/LanguageFlagIcons/flag-spain.svg
// module id = 1134
// module chunks = 1